<template>
  <el-dialog title="欠费明细" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="closeDialog" width="80vw">

    <div class="view-file-win">
      <div class="header-tip">
        欠费条数：{{toRound(houseMoneyCount)}} &nbsp;&nbsp;&nbsp;&nbsp;
        欠费金额：{{toRound(houseMoney)}} &nbsp;&nbsp;&nbsp;&nbsp;
        选择房产数：{{toRound(selectHouseMoneyCount)}} &nbsp;&nbsp;&nbsp;&nbsp;
        选择金额：{{toRound(selectHouseMoney)}}
      </div>
      <el-table
        v-loading="loading" :data="house_bill_order" height="60vh"
        border
        style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45" fixed></el-table-column>
        <el-table-column
          prop="h_name_date"
          label="房产信息" width="360" fixed></el-table-column>
        <el-table-column
          prop="charge_name"
          label="费项"
          width="150">
        </el-table-column>
        <el-table-column
          prop="BillDate"
          label="收费周期"
          width="150">
        </el-table-column>
        <el-table-column
          prop="charge"
          label="金额"
          width="100">
        </el-table-column>
        <el-table-column
          prop="h_name"
          label="业主">
        </el-table-column>
      </el-table>
    </div>
    <template slot="footer">
      <div>
        <el-button @click="dialogVisible=false">关 闭</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import ButlerHttp from "../common/ButlerHttp";

export default {
  name: "LegalHouseMoneyList",
  data(){
    return{
      dialogVisible: false,
      house_bill_order:[],
      loading: false,
      multipleSelection:[],
    }
  },
  methods: {
    show({project_id, house_id}){
      this.getHouseBill(project_id, house_id);
    },
    closeDialog(){
      this.dialogVisible = false;
      this.house_bill_order = [];
      this.loading = false;
    },
    getHouseBill(projectId, houseId){
      const that=this;
      ERP.showLoading()
      ButlerHttp.post("Legal/getHouseBill", {
        projectId: projectId,
        houseId: houseId
      }, res => {
        ERP.hideLoading();
        if (res.code) {
          that.dialogVisible = true;
          that.house_bill_order = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toRound(val,num=2){
      return Math.round(val*Math.pow(10,num))/Math.pow(10,num)
    }
  },
  computed:{
    houseMoney(){
      return this.house_bill_order.reduce((acc,cur)=>{
        return acc+((cur['charge']||0)*1)
      },0)
    },
    houseMoneyCount(){
      return this.house_bill_order.length
    },
    selectHouseMoney(){
      return this.multipleSelection.reduce((acc,cur)=>{
        return acc+((cur['charge']||0)*1)
      },0)
    },
    selectHouseMoneyCount(){
      return this.multipleSelection.length
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/LegalHouseMoneyList.vue